import { useToast } from '@/components/ui/use-toast';
import { useLoading } from '@/hooks/use-loading.hook';
import { getLogger } from '@/logger/get-logger';

export function useCopyNumber() {
  const { toast } = useToast();
  const {
    isLoading: isCopyingLoading,
    startLoading: startCopyingLoading,
    stopLoading: stopCopyingLoading,
  } = useLoading();

  async function copyNumber(phone: string) {
    startCopyingLoading();

    try {
      await navigator.clipboard.writeText(phone);

      toast.success('Número copiado com sucesso');
    } catch (error) {
      const logger = getLogger('useCopyNumber', {});
      logger.warn('Error copying phone number', { phone, error });
      toast.error('Erro ao copiar o número');
    } finally {
      stopCopyingLoading();
    }
  }

  return {
    isCopyingLoading,
    copyNumber,
  };
}
